// AI Generated
import {
    Component,
    Input,
    IterableDiffers,
    DoCheck,
    IterableDiffer,
} from '@angular/core';

@Component({
    selector: 'table-compliance',
    template: `
        <div class="text-nowrap text-v-middle table-compliance">
            <span class="button-monsido-icon nohover inner-t-mini inner-b-none inner-l-none inner-r-small text-right col-top" tabindex="0">
                <div class="page-count">
                    {{ number }}%
                </div>
                <div class="page-text hidden-print">
                    {{ btnWord | translate}}
                </div>
            </span>
            <span *ngIf="number">
                <mon-chart-doughnut [colors]="colors"
                                [hidden]="number >= 100"
                                class="inline-block hidden-print"
                                [labels]="labels"
                                [data]="data"
                                [size]="size"
                                [options]="options">
                </mon-chart-doughnut>
            </span>
            <span class="fas fa-check-circle text-light-green outer-l-smurf inline-block hidden-print"
                  *ngIf="number === 100"
                  [style.font-size]="(parseInt(size) + 3) + 'px'">
            </span>
        </div>
    `,
    styleUrls: ['./table-compliance.component.scss'],
    standalone: false,
})
export class TableComplianceComponent implements DoCheck {
    @Input() data: number[] = [];
    @Input() labels: string[] = [];
    @Input() indexNumber?: number;
    @Input() size: string = '35';
    @Input() btnWord: string = 'Compliance';

    number = 0;
    colors = ['#4dc0bd', '#dcdcdc'];
    options = {
        cutoutPercentage: 57,
        maintainAspectRatio: false,
        responsive: false,
        tooltips: {
            enabled: false,
        },
    };

    dataDiffer: IterableDiffer<any>;

    constructor (
        private iterableDiffers: IterableDiffers,
    ) {
        this.dataDiffer = this.iterableDiffers.find(this.data).create();
    }

    ngDoCheck (): void {
        const diffRes = this.dataDiffer.diff(this.data);
        if (diffRes && this.dataHasValue()) {
            this.evaluate();
        }
    }

    dataHasValue () {
        return !this.data.some(function (entry) {
            return isNaN(entry);
        });
    }

    evaluate (): void {
        let number = 0;
        let collectedNumber = 0;
        this.data?.forEach((data, index) => {
            if (index === this.indexNumber) {
                number = data;
            }
            collectedNumber += data;
        });
        this.number = this.calculate((number / collectedNumber) * 100 || 0);
    }

    calculate (num: number): number {
        let multiplied = num * 100;
        multiplied = num < 1 ? Math.ceil(multiplied) : num > 99 ? Math.floor(multiplied) : Math.round(multiplied);
        return multiplied / 100;
    }

    parseInt (value: string): number {
        return parseInt(value, 10);
    }
}
